import { useEffect, useState } from "react";
import { Link } from "react-router-dom";

import i18next from "i18next";

import { getPartnersMiniInfo } from "../../../../../info/allAirlines";

import Card from "../../../../ui/Card";

import { Cards, Title, Wrapper } from "./style";

export const PartnersListComponent = () => {
  const { t, language } = i18next;

  const [partners, setPartners] = useState([]);

  useEffect(() => {
    const getAllPartners = async () => {
      const result = await getPartnersMiniInfo(0);

      setPartners(result)
    };

    getAllPartners();
  }, []);

  return (
    <Wrapper>
      <Title>{t("partners")}</Title>

      <Cards>
        {partners.map((item, index) => {
          const destination = {
            pathname: `/airlines/${item.key}`,
            state: { ...item.name },
          };
          return (
            <Link key={index} to={destination}>
              <Card imageSrc={item.imageUrl} title={item.name[language]} />
            </Link>
          );
        })}
      </Cards>
    </Wrapper>
  );
};
